import { useEffect, useRef } from 'react'
import { useGlobalWhereby } from './useGlobalWhereby'
import { shouldLeaveGameForMessage, subscribeToCrossTabMessages } from './wherebyCrossTab'

// Drops this tab's stale game call when a sibling tab signals that the game is over. Taking the call OVER
// (moving it to another tab/device) is a different flow entirely — it goes through the server-side
// ownership claim and always needs the user's confirmation (useWherebyCallOwnership).
export const useWherebyCrossTabLeave = (): void => {
  const { callScope, isCallActive, killCall } = useGlobalWhereby()

  const stateRef = useRef({ callScope, isCallActive, killCall })
  stateRef.current = { callScope, isCallActive, killCall }

  useEffect(() => {
    return subscribeToCrossTabMessages((message) => {
      if (message.type !== 'leave-game-call') return
      const { callScope: scope, isCallActive: active, killCall: leave } = stateRef.current
      const willLeave = shouldLeaveGameForMessage(
        { isCallActive: active, callScopeKind: scope?.kind, callScopeTeamId: scope?.teamId },
        message
      )
      if (willLeave) {
        leave()
      }
    })
  }, [])
}
